<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t('menu.customFood')" center width="800px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog df-c-fs">

          <div class="left f1 df-l-c-fs">
            <div class="item">
              <div class="label f-xs">{{$t('menu.customFoodName')}}：</div>
              <input
                type="text" class="myinput f-xs"
                :placeholder="$t('menu.customFoodNamePlanceholder')"
                v-model="fData.name" ref="input2"
                @input="nameInput" />
            </div>
            <div class="item mt10">
              <div class="label f-xs">{{$t('menu.customFoodPrice')}}：</div>
              <InputCustom
                :inputable="true"
                inputWidth="320"
                :inputPlaceholder="$t('menu.customFoodPricePlanceholder')"
                :inputValue="fData.price" />
            </div>
            <div class="item mt10">
              <div class="label f-xs">{{$t('menu.customFoodPrinter')}}：</div>
              <el-select v-model="fData.label" clearable placeholder="">
                <el-option :label="x.label" :value="x.value" v-for="(x,i) in labelList" :key="i" />
              </el-select>
            </div>
            <div class="mt20">
              <div class="whitebtn-s" @click="downClick(9)">{{$t('menu.off9')}}</div>
              <div class="whitebtn-s ml10" @click="downClick(8)">{{$t('menu.off8')}}</div>
              <div class="whitebtn-s ml10" @click="downClick(5)">{{$t('menu.off5')}}</div>
            </div>
            <div class="mt10">
              <div class="whitebtn-s" @click="upClick(11)">+10%</div>
              <div class="whitebtn-s ml10" @click="upClick(12)">+20%</div>
              <div class="whitebtn-s ml10" @click="upClick(13)">+30%</div>
            </div>
          </div>

          <div class="right f1 df-l-c-ct">
            <Keyboard :inputValue.sync="fData.price" :decimalPlaces="{us:2,hk:1}[sysEnv_x]" priceModel showDoubleZero showMinus />
          </div>
          
        </div>
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div class="themebtn" @click="submitDialog">{{$t('common.comfirm')}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogCusfood',
  data() {
    return {
      isShowDialog: false,
      fData: {
        name: '',
        name_zh: '',
        name_en: '',
        fixed: false,
        label: '',
        price: ''
      },
      labelList: [],
      costOrigin: '',
    }
  },
  methods: {
    open(costOrigin) {
      this.costOrigin = costOrigin
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.$emit('close')
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.fData.name = ''
      this.fData.name_zh = ''
      this.fData.name_en = ''
      this.fData.fixed = false
      this.fData.label = ''
      this.fData.price = ''
    },

    nameInput(e) {
      this.fData.name_zh = ''
      this.fData.name_en = ''
      this.fData.fixed = false
    },
    downClick(num) {
      this.fData.name = this.$t('menu.off' + num)
      this.fData.name_zh = {
        9: '九折',
        8: '八折',
        5: '五折',
      }[num]
      this.fData.name_en = {
        9: '10% OFF',
        8: '20% OFF',
        5: '50% OFF',
      }[num]
      this.fData.fixed = true
      this.fData.price = (0 - this.costOrigin / 10 * (10 - num)).toFixed(0)
    },
    upClick(num) {
      this.fData.name = this.$t('menu.off' + num)
      this.fData.name_zh = {
        11: '服務費10%',
        12: '服務費20%',
        13: '服務費30%',
      }[num]
      this.fData.name_en = {
        11: 'Service Charge 10%',
        12: 'Service Charge 20%',
        13: 'Service Charge 30%',
      }[num]
      this.fData.fixed = true
      this.fData.price = (this.costOrigin / 10 * (num - 10)).toFixed(0)
    },
    submitDialog() {
      this.$emit('submitDialog', JSON.parse(JSON.stringify(this.fData)))
      this.close()
    },
    async getLabels() {
      if (this.currentShopId) {
        const _R = await this.getData('label', { shopId: this.currentShopId })
        console.log(`%c标签:`, 'color: #f00;', _R)
        this.labelList = _R.map(x => ({
          label: x.printerLabel,
          value: x.printerLabel
        }))
      }
    },
  },
  watch: {
    currentShopId() {
      this.getLabels()
    }
  },
  created() {
    this.getLabels()
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 20px 40px 0;
  .left{
    .item{
      .label{line-height: 36px;}
      /deep/.el-input__inner,
      .myinput{
        width: 320px;height: 50px;line-height: 50px;
        padding: 0 14px;
        background: #fff;
        border-radius: 4px;
        box-sizing: border-box;
        border: 1px solid #374978;
      }
      /deep/.el-input__inner,
      .myinput,
      .myinput::placeholder{
        font-size: 14px;
        color: #606266;
      }
    }
  }
}
</style>